import React, { 
  Component
} from 'react';

import {
  Theme,
  Tag
} from '@resultadosdigitais/tangram-components';

import EventTrackerAPI from 'src/event-tracker/api';
import EventEmitter from 'src/services/event_emitter';
import I18n from 'src/locales/i18n';

class IntegratorTag extends Component {
  render() {
    return (
      <Theme
        value={ Theme.kinds.lina }
        as={ 'span' }
        onMouseOver={ () => this.handleMouseOver(this.props.label) }
        onClick={ () => this.handleClick() }>
        <Tag style={ { cursor: 'pointer' } }>{ this.props.label }</Tag>
      </Theme>
    );
  }

  handleMouseOver() {
    EventTrackerAPI.postAnonymousTrackingEvent({
      event_name: 'Visitor hovered the mouse on a integrator tag',
      integrator_name: this.props.label,
      language: I18n.language
    });
  }

  handleClick() {
    EventEmitter.emit('INTEGRATOR_TAG_CLICK');

    EventTrackerAPI.postAnonymousTrackingEvent({
      event_name: 'Visitor clicked on a integrator tag',
      integrator_name: this.props.label,
      language: I18n.language
    });
  }
}

export default IntegratorTag;
